import React from "react";
import SwapVert from "@mui/icons-material/SwapVert";
import ChoiceMenu from "../ui/ChoiceMenu";
export default function SortDropdown(props) {
  return (
    <ChoiceMenu {...props} label="Sort" iconOnly>
      <SwapVert />
    </ChoiceMenu>
  );
}
